export default __webpack_public_path__ + "fbea929.png";